import React from "react";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import { GenderValue, MaritalStatusValue } from "@quest_editor/constants";
import { Prefecture, RegionWithPrefectures } from "@quest_editor/mocks";
import GenderField from "./GenderField";
import AgeRangeField, { AgeRange } from "./AgeRangeField";
import PrefectureField from "./PrefectureField";
import MaritalStatusField from "./MaritalStatusField";

const BasicAttrSection = ({
  gender,
  setGender,
  ageRangeRows,
  setAgeRangeRows,
  prefectures,
  regionsWithPrefectures,
  prefectureIds,
  setPrefectureIds,
  maritalStatus,
  setMaritalStatus,
}: {
  gender: GenderValue[];
  setGender: React.Dispatch<React.SetStateAction<GenderValue[]>>;
  ageRangeRows: AgeRange[];
  setAgeRangeRows: React.Dispatch<React.SetStateAction<AgeRange[]>>;
  prefectures: Prefecture[];
  regionsWithPrefectures: RegionWithPrefectures[];
  prefectureIds: string[];
  setPrefectureIds: React.Dispatch<React.SetStateAction<string[]>>;
  maritalStatus: MaritalStatusValue[];
  setMaritalStatus: React.Dispatch<React.SetStateAction<MaritalStatusValue[]>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_edit_target.section.basic_attr")}
      rows={[
        {
          label: t("quest_edit_target.field.basic_attr.gender.name"),
          children: <GenderField gender={gender} setGender={setGender} />,
        },
        {
          label: t("quest_edit_target.field.basic_attr.age.name"),
          children: (
            <AgeRangeField
              ageRangeRows={ageRangeRows}
              setAgeRangeRows={setAgeRangeRows}
            />
          ),
        },
        {
          label: t("quest_edit_target.field.basic_attr.prefecture.name"),
          children: (
            <PrefectureField
              prefectures={prefectures}
              regionsWithPrefectures={regionsWithPrefectures}
              prefectureIds={prefectureIds}
              setPrefectureIds={setPrefectureIds}
            />
          ),
        },
        {
          label: t("quest_edit_target.field.basic_attr.marital_status.name"),
          children: (
            <MaritalStatusField
              maritalStatus={maritalStatus}
              setMaritalStatus={setMaritalStatus}
            />
          ),
        },
      ]}
    />
  );
};

export default BasicAttrSection;
